import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private isLoading: boolean = false;

  constructor() {}

  showLoading(): void {
    this.isLoading = true;
  }

  hideLoading(): void {
    this.isLoading = false;
  }

  loadingState(): boolean {
    return this.isLoading;
  }
}
